document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".scrolling-images-skip").forEach((button) => {
    const nextSection = button.closest('.scrolling-images-section').nextElementSibling;

    if(!nextSection) return;

    function checkPosition() {
      const buttonRect = button.getBoundingClientRect();
      const parentRect = button.closest('.scrolling-images').getBoundingClientRect();

      const aboveParent = buttonRect.top <= parentRect.top;
      const belowParent = buttonRect.bottom > parentRect.bottom;

      if (!aboveParent && !belowParent) {
        button.classList.add("in-position");
      } else {
        button.classList.remove("in-position");
      }
    }

    window.addEventListener("scroll", checkPosition, { passive: true });
    window.addEventListener("resize", checkPosition);
    checkPosition();

    button.addEventListener('click', (e) => {
      e.preventDefault();

      nextSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      
      nextSection.setAttribute('tabindex', '-1');
      nextSection.focus({ preventScroll: true });
      
      setTimeout(() => {
        nextSection.removeAttribute('tabindex');
      }, 100);
    });
  });
});